import $i from "~/i18n";

  export const getAllUser = async (context, payload) => {
    try {
      let body = { ...payload }
      let page = body.page || 1
      let { data } = await axios.post('/users/get-all', { page_num: page })
      if (data.state !== 200) return
      if (data.users.length > 0) {
        context.commit('setAllUser', data.users)
      }
      return data.users.length
      // console.log(data);
    } catch (error) {
      console.log(error)
    }
  };
  export const remove =  async (context, payload) => {
    try {
      let body = { ...payload }
      let id = body.user_id
      let { data } = await axios.post('/users/delete', { user_id: id })
      if (data.state !== 200) return
      // context.commit('setAllUser', data.users)
      // console.log(data);
    } catch (error) {
      console.log(error)
    }
  }


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/users/actions.js